import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "digitaltwin-tree"
  }, [_vm.fetchError === 'TOO_MANY_RESULTS' ? [_c('div', {
    staticClass: "px-4 pt-6"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.tooManyResults')) + "\n    ")])] : _vm.twinTreeItems.length === 0 && !_vm.isLoading ? [_c('div', {
    staticClass: "px-4 pt-6"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.noResults')) + "\n    ")])] : [_c(VTreeview, {
    class: _vm.searchEnabled == true ? 'mt-4' : '',
    attrs: {
      "items": _vm.twinTreeItems,
      "open": _vm.open,
      "load-children": _vm.fetchChildren,
      "hoverable": true,
      "color": _vm.color,
      "transition": true,
      "expand-icon": "fal fa-angle-down",
      "item-text": "title",
      "item-key": "id"
    },
    on: {
      "update:open": function ($event) {
        _vm.open = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [_vm.itemType(item) === _vm.itemTypeLoadMore ? [_c('div', {
          staticClass: "load-more"
        }, [_c(VBtn, {
          staticClass: "v-btn-x",
          attrs: {
            "color": _vm.color
          },
          on: {
            "click": function ($event) {
              return _vm.triggerLoadMore(item);
            }
          }
        }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])], 1)] : _vm.getTwinTreeIcon(item) ? [_c(VIcon, {
          class: (_vm.treeItemIsState(item) ? '' : 'ml-2') + ` ${_vm.twinItemIconClass(item)}`,
          style: `width: 30px; ${_vm.canSelect(item) ? '' : 'opacity: 0.5'}`,
          attrs: {
            "size": "24"
          },
          domProps: {
            "textContent": _vm._s(`${_vm.getTwinTreeIcon(item)}`)
          }
        })] : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [_vm.itemType(item) === _vm.itemTypeLoadMore ? void 0 : _vm.itemType(item) === _vm.itemTypeState ? [_c(VCheckbox, {
          staticClass: "ml-2 pt-0 mt-0",
          attrs: {
            "color": _vm.color,
            "label": `${item.title} (${item.key})`
          },
          on: {
            "change": function ($event) {
              return _vm.stateSelectionToggled(item);
            }
          },
          model: {
            value: item.selected,
            callback: function ($$v) {
              _vm.$set(item, "selected", $$v);
            },
            expression: "item.selected"
          }
        })] : _vm.itemType(item) === _vm.itemTypeStatesRoot ? [_vm._v(_vm._s(item.title))] : [_c('div', {
          class: _vm.twinItemLabelClass(item),
          style: _vm.canSelect(item) ? '' : 'opacity: 0.5',
          on: {
            "click": function ($event) {
              _vm.canSelect(item) ? _vm.didToggleSelection(item) : null;
            }
          }
        }, [_vm._t("title", function () {
          return [_vm._v("\n              " + _vm._s(item.title) + "\n              "), _c('span', {
            staticStyle: {
              "font-size": "10px"
            }
          }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")])];
        }, {
          "item": item
        })], 2)]];
      }
    }])
  })]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };